import React, { PropsWithChildren } from 'react';
import Modal, { ModalProps } from '@/Components/Modal';
import IconClose from '@/svgs/delete.svg?react';
import useHotkeys from '@/Hooks/useHotKeys';

DialogModal.Content = function DialogModalContent({
  title,
  onClose,
  children,
}: PropsWithChildren<{ title: string; onClose: () => void }>) {
  return (
    <div className="px-6 py-4">
      <div className="flex justify-between">
        <h3 className="font-medium text-brand-dark-100/90 dark:text-brand-light-100">
          {title}
        </h3>
        <button onClick={onClose}>
          <IconClose className="h-5 w-5 text-brand-dark-100/40 dark:text-brand-light-100" />
        </button>
      </div>

      <div className="mt-4 text-sm">{children}</div>
    </div>
  );
};

DialogModal.Footer = function DialogModalFooter({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <div className="bg-brand-50 px-6 py-4 text-right dark:bg-brand-dark-75">
      {children}
    </div>
  );
};

export default function DialogModal({
  children,
  ...modalProps
}: PropsWithChildren<ModalProps>) {
  useHotkeys({ esc: modalProps.onClose });

  return <Modal {...modalProps}>{children}</Modal>;
}
